import React from "react";
import { Group, Text, Button, Tooltip } from "@mantine/core";
import { useAppDispatch, useAppSelector } from "../../../app/hooks";
import { setActiveRoomColoringIdInRedux } from "../../designSlice";
import { selectRfpStandardRoomRows, selectActiveRoomColoringId } from "../RFPBarSelectors";
import { id } from "zod/v4/locales";

export const RFPBarStandardRoomSection: React.FC = () => {
  const dispatch = useAppDispatch();

  const rows = useAppSelector(selectRfpStandardRoomRows);
  const activeRoomColoringId = useAppSelector(selectActiveRoomColoringId);

  return (
    <Group gap="sm" align="center" wrap="nowrap">
      {rows.map((row) => {
        const poengActive = row.validationId && activeRoomColoringId === row.validationId;
        const beslutningActive = row.decisionId && activeRoomColoringId === row.decisionId;

        return (
          <Group key={row.discipline} gap={6} align="center" wrap="nowrap">
            <Tooltip
              label={`Disiplin: ${row.discipline}`}
              position="bottom"
              withArrow
              openDelay={250}
            >
              <Text size="sm" fw={700} style={{ minWidth: 18, textAlign: "center" }}>
                RI{row.discipline}
              </Text>
            </Tooltip>

            <Tooltip
              label="Poeng: viser farge basert på hvor godt rommet matcher standardrommet (matchrate)."
              position="bottom"
              withArrow
              openDelay={250}
            >
              <span>
                <Button
                  size="sm"
                  radius="xl"
                  variant={poengActive ? "filled" : "subtle"}
                  color="blue"
                  disabled={!row.validationId}
                  onClick={() =>
                    row.validationId && dispatch(setActiveRoomColoringIdInRedux(row.validationId))
                  }
                  style={{ paddingLeft: 14, paddingRight: 14, fontWeight: 600 }}
                >
                  Poeng
                </Button>
              </span>
            </Tooltip>

            <Tooltip
              label="Beslutning: viser farge basert på manuell status (Godkjent / Godkjent med avvik / Må kontrolleres)."
              position="bottom"
              withArrow
              openDelay={250}
            >
              <span>
                <Button
                  size="sm"
                  radius="xl"
                  variant={beslutningActive ? "filled" : "subtle"}
                  color="blue"
                  disabled={!row.decisionId}
                  onClick={() =>
                    row.decisionId && dispatch(setActiveRoomColoringIdInRedux(row.decisionId))
                  }
                  style={{ paddingLeft: 14, paddingRight: 14, fontWeight: 600 }}
                >
                  Beslutning
                </Button>
              </span>
            </Tooltip>
          </Group>
        );
      })}
    </Group>
  );
};
